import React, { useState } from "react";
import send from "../../../assets/img/icons/send-2.svg";
import nowishlist from "../../../assets/img/dashboard/nowishlist.svg";
import PlaceCard from "../../common/PlaceCard";
import useFetch from "../../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
const MyTripsTable = ({ arr }) => {
  const navigate = useNavigate()
  return (
    <div className="UserReserve--table">
      <div className="UserReserve--table--head">
        <div >نام میزبان</div>
        <div>نام اقامتگاه</div>
        <div>شب های اقامت</div>
        <div>تاریخ درخواست</div>
        <div>وضعیت</div>
      </div>
      {arr.map(i =>
        <div  onClick={()=>  navigate(`/place/${i.residence_code}/${i.residence_slug}`)} className="UserReserve--table--body cursor-pointer">
          <div className="flex gap-[8px] items-center">
            <img src={i.avatar} />
            <div>
              {i.user.full_name}
            </div>
          </div>
          <div className="bg-[#DCE1E3] rounded-[12px] p-[10px] font-[500] w-max">
            {i.residence_title}
          </div>
          <div>
            {" "}شب {i.count_days}
          </div>
          <div>
            {i.reserve_to_date} تا {i.reserve_from_date}
          </div>
          <div>
            {i.status}
          </div>
        </div>
      )}
    </div>
  );
};
const UserMyTrips = () => {
  const [myTripsInfo, setmyTripsInfo] = useState([]);
  const fetchmyTrips = useFetch({
    method: "get",
    url: "api/mytrips",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setmyTripsInfo(res.data.reserves);
    }
  });

  return (
    <div className="WishList">
      <div className="d-flex-space">
        <h3>لیست سفرهای من</h3>
        <div className="send-box mr-[16px]">
          <img src={send} />
          <p className="mr-[8px]">اشتراک گذاری کردن</p>
        </div>
      </div>
      <hr className="mt-[30px] mb-[50px]" />
      {myTripsInfo.length > 0 &&
        // ? <div className="WishList--grid">
        //     {myTripsInfo.map(i =>
        //       <PlaceCard
        //         img={`${i.thumbnail.path}`}
        //         isfast={i.instant_reserve === 1 ? true : false}
        //         rate={i.rating_value}
        //         info={i.address}
        //         title={i.title}
        //         key={i.id}
        //         cost={i.price}
        //         tip={i.special_discount_in_24}
        //         code={i.code}
        //         slug={i.slug}
        //         wishlist={i.wishlist}
        //         id={i.id}
        //         room={i.rooms_count}
        //         city={i.city}
        //         type={i.type}
        //       />
        //     )}
        //   </div>
        // : <div className="nowishlist center-column">
        //     <img src={nowishlist} />
        //     <h6>هنوز سفری نرفته اید !!</h6>
        //   </div>
      
      
      <MyTripsTable arr={myTripsInfo}/>
      }
    </div>
  );
};

export default UserMyTrips;
